import {
    recordTypeLabel,
    sourceTypeToRecordType,
} from '../../constants/centralProductMaster.constants';

interface CpmTypeChipProps {
    recordType: string;
    className?: string;
}

export default function CpmTypeChip({ recordType, className = '' }: CpmTypeChipProps) {
    const normalized = String(sourceTypeToRecordType(recordType)).toUpperCase();
    const styles =
        normalized === 'BRAND'
            ? 'bg-[var(--cpm-brand-navy)] text-white border border-[var(--cpm-brand-navy)]'
            : normalized === 'PRODUCT'
              ? 'bg-[var(--cpm-purple-tint-13)] text-[var(--cpm-brand-purple)] border border-[var(--cpm-purple-accent-border)]'
              : 'bg-[var(--cpm-info-bg)] text-[var(--cpm-info-text)] border border-[var(--cpm-info-border)]';

    return (
        <span style={{ justifySelf: 'start', alignSelf: 'center', display: 'block' }}>
            <span
                className={[
                    'inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-extrabold uppercase tracking-[0.05em]',
                    styles,
                    className,
                ].join(' ')}
                style={{ width: 'max-content', maxWidth: 'max-content', whiteSpace: 'nowrap' }}
            >
                {recordTypeLabel(recordType)}
            </span>
        </span>
    );
}
